<div class="dialog-content-container">
  <div class="dialog-header mb-2">
    <img
      src="assets/images/info.svg"
      [alt]="'emailVerification.iconAlt' | translate"
      class="dialog-icon"
    />
    <h3 class="dialog-title">{{ data.titleKey | translate }}</h3>
  </div>
  <div class="dialog-content">
    <p class="dialog-content-text mb-4">
      {{ data.messageKey | translate }} <strong>{{ email }}</strong>
    </p>
    <button
      pButton
      type="button"
      [label]="'emailVerification.verify' | translate"
      class="p-button-primary w-full text-sm"
      [loading]="sending"
      [disabled]="sent"
      (click)="onSend()"
    ></button>
    @if (sent) {
      <p class="dialog-content-text text-sm mt-2">
        {{ 'emailVerification.sent' | translate }}
      </p>
    }
    <button
      pButton
      type="button"
      [label]="'emailVerification.close' | translate"
      class="p-button-text p-button-secondary w-full text-sm mt-2"
      (click)="ref.close()"
    ></button>
  </div>
</div>
